/* eslint-disable react/prop-types */
import {Box, Card, CardActionArea, CardContent, Stack, Typography} from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import FormTemplatePreviewVisual from './FormTemplatePreviewVisual';
import WizardPreviewVisual from './WizardPreviewVisual';
import EmailPreviewVisual from './EmailPreviewVisual';

const CreateFormSelectMode = ({
                                  onWizard,
                                  onBlank,
                                  onTemplate,
                                  onSchoolTemplate,
                                  onEmail,
                              }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                overflow: 'auto',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                border: '1px solid #e0e0e0',
                borderRadius: 1,
                backgroundColor: '#fff',
                p: 1,
            }}
        >
            <Box sx={{m: 3}}>
                <Typography variant="h4" textAlign="center" gutterBottom>
                    Create a Form or Email
                </Typography>
                <Typography variant="body1" textAlign="center" color="text.secondary">
                    Choose how you’d like to get started
                </Typography>

                <Stack
                    direction={{
                        xs: 'column',
                        sm: 'row'
                    }}
                    rowGap={4}
                    columnGap={4}
                    justifyContent="center"
                    flexWrap="wrap"
                    mt={5}
                >
                    <Card
                        sx={{
                            width: 300,
                            border: '1px solid #ddd',
                            borderRadius: 2,
                        }}
                    >
                        <CardActionArea
                            onClick={onWizard}
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <WizardPreviewVisual category="Staff"/>
                            <CardContent>
                                <Typography variant="h6" textAlign="center" gutterBottom>
                                    Form Creation Wizard
                                </Typography>
                                <Typography variant="body2" textAlign="center" color="text.secondary">
                                    Answer a few questions and get the template that is right for you.
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>

                    <Card
                        sx={{
                            width: 300,
                            border: '1px solid #ddd',
                            borderRadius: 2,
                        }}
                    >
                        <CardActionArea
                            onClick={onTemplate}
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <FormTemplatePreviewVisual category="Admissions"/>
                            <CardContent>
                                <Typography variant="h6" textAlign="center" gutterBottom>
                                    Use Admicity Template
                                </Typography>
                                <Typography variant="body2" textAlign="center" color="text.secondary">
                                    Browse our pre-built templates and customise them for your needs.
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>

                    <Card
                        sx={{
                            width: 300,
                            border: '1px solid #ddd',
                            borderRadius: 2,
                        }}
                    >
                        <CardActionArea
                            onClick={onEmail}
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <EmailPreviewVisual category="Send an Email"/>

                            <CardContent>
                                <Typography variant="h6" textAlign="center" gutterBottom>
                                    Send an Email
                                </Typography>
                                <Typography variant="body2" textAlign="center" color="text.secondary">
                                    Start a blank form set up as an email communication.
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>

                    <Card
                        sx={{
                            width: 300,
                            border: '1px solid #ddd',
                            borderRadius: 2,
                        }}
                    >
                        <CardActionArea
                            onClick={onSchoolTemplate}
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <FormTemplatePreviewVisual category="School Template"/>
                            <CardContent>
                                <Typography variant="h6" textAlign="center" gutterBottom>
                                    Use School Template
                                </Typography>
                                <Typography variant="body2" textAlign="center" color="text.secondary">
                                    Choose from templates your school has already created and saved.
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>

                    <Card
                        sx={{
                            width: 300,
                            border: '1px solid #ddd',
                            borderRadius: 2
                        }}
                    >
                        <CardActionArea
                            onClick={onBlank}
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <Box
                                sx={{
                                    width: '100%',
                                    height: 190,
                                    backgroundColor: '#f9f9f9',
                                    borderBottom: '1px solid #eee',
                                    borderTopLeftRadius: 8,
                                    borderTopRightRadius: 8,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#555',
                                }}
                            >
                                <AddRoundedIcon sx={{fontSize: 64}}/>
                            </Box>

                            <CardContent>
                                <Typography variant="h6" textAlign="center" gutterBottom>
                                    Start from Blank
                                </Typography>
                                <Typography variant="body2" textAlign="center" color="text.secondary">
                                    Create your form layout from scratch with full control.
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>

                </Stack>
            </Box>
        </Box>
    );
};

export default CreateFormSelectMode;
